"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    gatewayJwtService: ()=>gatewayJwtService
});
const index_js_namespaceObject = require("../jwt/index.js");
const convertGatewayJwtKey = (value)=>{
    if ('sinf-boe' === value) return 'sinf';
    if ('volcgroup-boe' === value) return 'volcgroup';
    return value;
};
const getService = (uniqueKey)=>index_js_namespaceObject.bytecloudAsyncJwtService.getServiceByUniqueKey(convertGatewayJwtKey(uniqueKey)).then((service)=>service);
const gatewayJwtService = {
    logout: (uniqueKey, next)=>{
        getService(uniqueKey).then((service)=>service.logout(next));
    },
    getJwt: (uniqueKey)=>getService(uniqueKey).then((service)=>service.getJwt()),
    setCache: (uniqueKey, jwt)=>{
        index_js_namespaceObject.bytecloudAsyncJwtService.setCache(convertGatewayJwtKey(uniqueKey), jwt);
    },
    getService: (uniqueKey)=>getService(uniqueKey)
};
const checkType = (value)=>value;
const gateway_jwt_service_value = 'online';
checkType(gateway_jwt_service_value);
exports.gatewayJwtService = __webpack_exports__.gatewayJwtService;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "gatewayJwtService"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
